/**
 * Datepicker.
 */
window.datepicker = function() {
    $(".datepicker").datepicker({
        dateFormat: window.datepicker_format ? window.datepicker_format : "dd-mm-yy",
        changeMonth: true,
        changeYear: true,
        regional: window.locale ? window.locale : 'nl',
        yearRange: "1920:c"
    });
};
